import axiosInstance from '@/shared/api/axios';
import type { ApiReturnCreateBody, ReturnRequest } from '@/shared/types/api/returns';
import type { ApiParcelsMyGetResponse } from '@/shared/types/api/parcels';

export const apiReturnCreate = async (body: ApiReturnCreateBody): Promise<ReturnRequest> => {
  const { data } = await axiosInstance.post<ReturnRequest>('/returns', body);
  return data;
};

export const apiReturnsAvailableParcels = async (): Promise<ApiParcelsMyGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsMyGetResponse>('/returns/available-parcels');
  return data;
};
